import { $Props } from '@Ravnur-Inc/core/typings/tsx';
import { Prop } from '@Ravnur-Inc/decorators';
import { Vue } from 'vue-class-component';
import { Metadata$Field } from '../types/Metadata';
import sortBy from '@Ravnur-Inc/nanoutils/sortBy';
import { Checkable, toCheckable } from '@/transformers/checkable';
import SearchInput from '@/components/search-input/search-input';

import './add-metadata-fields-modal.scss';

const CN = 'add-metadata-fields-modal';

class Props {
  value: Metadata$Field[];
  fields: Metadata$Field[];
}

export default class AddMetadataFieldsModal extends Vue {
  declare $props: $Props<Props, unknown, 'value'>;

  @Prop({ type: Object as () => Metadata$Field, default: [] }) fields: Metadata$Field[];
  @Prop({ type: Object as () => Metadata$Field, default: [] }) value: Metadata$Field[];
  @Prop({}) close: () => void;

  checkableFields: Checkable<Metadata$Field>[] = [];
  searchString = '';
  isShowSelected = false;

  get selected() {
    return this.checkableFields.filter((f) => f.checked).map((f) => f.entity);
  }

  get filteredValues() {
    let fields = this.checkableFields;

    if (this.searchString) {
      fields = fields.filter(({ entity: { name } }) =>
        name.toLowerCase().includes(this.searchString.toLocaleLowerCase())
      );
    }

    if (this.isShowSelected) {
      return fields.filter((f) => f.checked);
    }

    return fields;
  }

  confirm() {
    this.$emit('update:value', this.selected);
    this.close();
  }

  render() {
    return (
      <popup
        class={CN}
        closeLabel={this.$t('common', 'action__cancel')}
        confirmLabel={this.$t('common', 'action__submit')}
        header={this.$t('media', 'metadata-add-field')}
        onClose={this.close}
        onConfirm={this.confirm}
      >
        <div class={`${CN}__container`}>
          <SearchInput vModel={[this.searchString, 'value']} />
          <div class={`${CN}__filters`}>
            <r-button
              color="primary"
              mode={this.isShowSelected ? 'secondary' : 'standard'}
              onclick={this.showAll}
            >
              {this.$t('media', 'metadata-all')}
            </r-button>
            <r-button
              color="primary"
              mode={this.isShowSelected ? 'standard' : 'secondary'}
              onclick={this.showSelected}
            >
              {this.$t('media', 'metadata-selected', { count: this.selected.length })}
            </r-button>
          </div>
          <div class={`${CN}__fields`}>
            {this.filteredValues.length > 0 ? (
              this.filteredValues.map((field) => (
                <checkbox
                  key={field.id}
                  label={field.entity.name}
                  vModel={[field.checked, 'value']}
                />
              ))
            ) : (
              <div class={`${CN}__no-fields`}>{this.$t('media', 'metadata-no-fields')}</div>
            )}
          </div>
        </div>
      </popup>
    );
  }

  showAll() {
    this.isShowSelected = false;
  }

  showSelected() {
    this.isShowSelected = true;
  }

  initFields() {
    const list = sortBy((f: Metadata$Field) => f.name.toLowerCase(), this.fields);
    this.checkableFields = toCheckable(
      list,
      this.value.map((v) => v.id)
    );
  }

  created() {
    this.initFields();
  }
}
